import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class PreviousPregnacy extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      Year: "",
      EvolutionPreviousPregnancy: "",
      ModeDeliveryMode: "",
      InfantWeight: "",
      Sex: "",
      InfantState: "",
      myParentTrigger: "",
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }
  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".yesAnswer").click(function () {
      $(".hiddenPart").show();
    });
    $(".noAnswer").click(function () {
      $(".hiddenPart").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  getTableValues(event) {
    this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  formatTableOutput(data) {
    // let finalobj = [];
    let finalobj = {};
    for (let i = 0; i < data.length; i++) {
      let trimobj = {};
      trimobj.Year = data[i][0];
      trimobj.EvolutionPreviousPregnancy = data[i][1];
      trimobj.ModeDeliveryMode = data[i][2];
      trimobj.InfantWeight = data[i][3];
      trimobj.Sex = data[i][4];
      trimobj.InfantState = data[i][5];
      finalobj = trimobj;
    }
    this.state.tablevaluesglobal = finalobj;
    // console.log(finalobj);
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    let finalpayload = this.state.tablevaluesglobal;
    // console.log(finalpayload);
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/pregnancyhistorytable/main",
        finalpayload,
        { headers: headers }
      )
      .then((response) => {
        this.setState({
          loading: false
        })

        if (response.status == 200) {
          $("#SubmitSuccess").show();
          $("#SubmitError").hide();
        } else {
          $("#SubmitSuccess").hide();
          $("#SubmitError").show();

          // $(response).each(function (index) {
          //     var individualResult = '<div className="card"> <div className="card-body">' + index.name + '</div> </div>'
          //     $('.resultDisplay').append(individualResult);
          // });
          // $('.resultDisplay').show();
          this.setState({ response: response });
          // console.log(response)resultDisplay
          //
        }
      })
      .catch((error) => {
        $("#SubmitSuccess").hide();
        $("#SubmitError").show();
        console.log(error);
      });
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  render() {
    //Editable table variables
    const data = [
      ["Prolonged /obstructed labour", "", ""],
      ["Hypertension/ Preeclampsia/eclampsia", "", ""],
      ["Antepartum Hemorrhage", "", ""],
      ["Postpartum Hemorrhage", "", ""],
      ["Feto-maternal infection", "", ""],
      ["Diabetes", "", ""],

      // ["4th", "", ""],
    ];
    const columns = [
      "Complications",
      "Pregnancy/date ",
      "Evolution and treatment ",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      Year,
      EvolutionPreviousPregnancy,
      ModeDeliveryMode,
      InfantWeight,
      Sex,
      InfantState,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form id="obsform" onSubmit={this.handleSubmit}>
              <div className="hiddenPart">
                <MDBCard>
                  <MDBCardHeader
                    tag="h3"
                    className="text-center font-weight-bold text-capitalise py-4"
                  >
                    Previous Pregancy(ies)
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBTableEditable
                      onChange={(value) => this.handleTableChange(value)}
                      getValue={(value) => this.getTableValues(value)}
                      myParentTrigger={this.state.myParentTrigger}
                      id="editablecard"
                      data={data}
                      columns={columns}
                      striped
                      bordered
                    />
                  </MDBCardBody>
                </MDBCard>
              </div>
              
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
              {/* <div className="alert alert-danger contactAdmin" style={displayHidden} role="alert">
                                <strong>Wait! </strong>Contact Administrator to get account approval.
                            </div> */}
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PreviousPregnacy;
